import { render, staticRenderFns } from "./jiankang-detail.vue?vue&type=template&id=377bc799&scoped=true&"
import script from "./jiankang-detail.vue?vue&type=script&lang=ts&"
export * from "./jiankang-detail.vue?vue&type=script&lang=ts&"
import style0 from "./jiankang-detail.vue?vue&type=style&index=0&id=377bc799&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377bc799",
  null
  
)

export default component.exports